import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Link } from '@hivebrite/design-system/Link';

import { getIsExternalLink, getLink } from 'hb-builder/utils/links';

interface HeadlineLinkProps {
  children: React.ReactNode;
  href?: string;
  isBackoffice?: boolean;
  target?: string;
}

export const HeadlineLink = ({
  children,
  href,
  isBackoffice,
  target,
}: HeadlineLinkProps) => {
  if (!href || isBackoffice) {
    return (
      <StyledHeadlineSimpleLink data-testid="headline-fake-link">
        {children}
      </StyledHeadlineSimpleLink>
    );
  }

  const domain = window.location.hostname;

  const linkProps = {
    forceDefaultLink: getIsExternalLink(href, domain),
    target,
    to: getLink(href, domain),
  };

  return <StyledHeadlineLink {...linkProps}>{children}</StyledHeadlineLink>;
};

export default HeadlineLink;

const getStyles = () => css`
  &:hover * {
    color: ${({ theme }) => theme.colors.link};
    text-decoration: underline;
  }
`;

const StyledHeadlineSimpleLink = styled(Box)`
  ${getStyles}
  cursor: pointer;
`;

const StyledHeadlineLink = styled(Link)`
  ${getStyles}
  text-decoration: none !important;
`;
